import { ControllerRenderProps } from 'react-hook-form'
import { Checkbox } from '@/components/ui/checkbox/checkbox'

export const CheckBoxInput = ({
  field,
  id,
  transactionName,
}: {
  field: ControllerRenderProps
  id: string
  /**
   * Transaction name for RUM monitoring.
   * Required for observability - tracks user interactions in Elastic APM.
   * Format: area.page.field_name (e.g., "forms.fd02.consent_checkbox")
   */
  transactionName: string
}) => {
  return <Checkbox id={id} {...field} transactionName={transactionName} />
}
